__turbopack_context__.v({
  "root": "RichText-module__YAa4nq__root",
});
